import { call, put, takeEvery } from 'redux-saga/effects';
import { settingApi } from '../api/settingApi';
import {
  GET_LICENSES_REQUEST,
  GET_LICENSES_SUCCESS,
  GET_LICENSES_FAILURE,
  GET_TRACK_USAGE_REQUEST,
  GET_TRACK_USAGE_SUCCESS,
  GET_TRACK_USAGE_FAILURE,
} from '../constants/settingConstants';

function* getLicensesSaga(action) {
  try {
    const response = yield call(settingApi.getLicenses, action.payload);
    yield put({ type: GET_LICENSES_SUCCESS, payload: response });
  } catch (error) {
    yield put({
      type: GET_LICENSES_FAILURE,
      payload: error.response?.data?.message || error.message || 'Failed to fetch licenses',
    });
  }
}

function* getTrackUsageSaga(action) {
  try {
    const response = yield call(settingApi.getTrackUsage, action.payload);
    yield put({ type: GET_TRACK_USAGE_SUCCESS, payload: response });
  } catch (error) {
    yield put({
      type: GET_TRACK_USAGE_FAILURE,
      payload: error.response?.data?.message || error.message || 'Failed to fetch track usage',
    });
  }
}

function* settingSaga() {
  yield takeEvery(GET_LICENSES_REQUEST, getLicensesSaga);
  yield takeEvery(GET_TRACK_USAGE_REQUEST, getTrackUsageSaga);
}

export default settingSaga;